import { Link, useLocation, useNavigate } from "react-router-dom";
import { knowledgeBaseLabel } from "@/lib/knowledgeBaseRegistry";
import { knowledgeOverviewPath, knowledgePathAfterBaseSwitch } from "@/lib/knowledgePaths";
import { useKnowledgeBases } from "@/pages/knowledge/useKnowledgeBases";

export function KnowledgeBaseSwitcher() {
  const navigate = useNavigate();
  const location = useLocation();
  const { bases, hasBases, activeId, setActive } = useKnowledgeBases();

  function onBaseChange(nextId: string) {
    if (nextId === activeId) return;
    setActive(nextId);
    const listPath = knowledgePathAfterBaseSwitch(location.pathname, nextId);
    if (listPath) {
      void navigate(listPath);
    } else if (location.pathname.includes("/knowledge/bases/")) {
      void navigate(`/knowledge/bases/${encodeURIComponent(nextId)}`);
    }
  }

  if (!hasBases) {
    return (
      <div className="flex flex-wrap items-center gap-2 rounded-lg border border-dashed border-slate-300 bg-slate-50 px-3 py-2 text-sm dark:border-white/15 dark:bg-slate-900/40">
        <span className="text-slate-600 dark:text-slate-300">No knowledge base yet.</span>
        <Link
          to={knowledgeOverviewPath()}
          className="text-sm font-medium text-indigo-600 hover:text-indigo-500 dark:text-indigo-300"
        >
          Create one
        </Link>
      </div>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm dark:border-white/10 dark:bg-slate-900/40">
      <label className="flex flex-wrap items-center gap-2 text-slate-700 dark:text-slate-200">
        <span className="font-medium">Knowledge base</span>
        <select
          value={activeId}
          onChange={(event) => onBaseChange(event.target.value)}
          className="rounded-md border border-slate-300 bg-white px-2 py-1 text-sm dark:border-white/20 dark:bg-slate-950"
          aria-label="Active knowledge base"
        >
          {bases.map((base) => (
            <option key={base.id} value={base.id}>
              {knowledgeBaseLabel(base)}
            </option>
          ))}
        </select>
      </label>
      <Link
        to="/knowledge"
        className="text-sm font-medium text-indigo-600 hover:text-indigo-500 dark:text-indigo-300"
      >
        Manage bases
      </Link>
    </div>
  );
}
